import { produce } from "immer";
import { CLEAR_ALL_ERROR_MESSAGE, CLEAR_ERROR_MESSAGE, GET_API_DATA_LIST, LOAD_API_DATA, RESET_API_DATA, RESET_NEWASSETS_FORM, SET_API_DATA, SET_ERROR_MESSAGE, SET_FORM_OPTION, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "./home.type";
const INITAL_STATE = {
    apiData: {
        regionCountry: {
            loading: false,
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        dataAssests: {
            loading: false,
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        dataProducts: {
            loading: false,
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        domainSubDomain: {
            loading: false,
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        adlsDirectory: {
            loading: false,
            status: "idle",
            isError: false,
            errorMessage: "",
            data: []
        },
      
    },
    formData: {
        subDomain: {
            value: "",
            valueAsObj: {},
            options: [
                { data_prod_name: 'Vendor', code: 'masterData' },
                { data_prod_name: 'Supply', code: 'supply' },
                { data_prod_name: 'R&D', code: 'rnd' },
                { data_prod_name: 'Finance', code: 'finance' },
                { data_prod_name: 'Consumer', code: 'consumer' },
                { data_prod_name: 'Product', code: 'product' },
                { data_prod_name: 'Customer', code: 'customer' },
                { data_prod_name: 'Geo', code: 'geo' },
                { data_prod_name: 'Promotion', code: 'promotion' },
                { data_prod_name: 'Sales Force', code: 'salesForce' },
            ],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        productOwner: {
            value: "",
            valueAsObj: {},
            options: [
                { data_prod_name: 'AMAZON', code: 'amazon' },
                { data_prod_name: 'WALLMART', code: 'wallmart' },
            ],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        assestName: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        assestDescription: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        frequency: {
            value: "",
            valueAsObj: {},
            options: [
                { name: "DAILY" },
                { name: "WEEKLY" },
                { name: "MONTHLY" }
            ],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        domain: {
            value: "",
            valueAsObj: {},
            options: [
                { data_prod_name: 'Master Data', code: 'masterData' },
                { data_prod_name: 'Supply', code: 'supply' },
                { data_prod_name: 'Demand', code: 'demand' },
                { data_prod_name: 'R&D', code: 'rnd' },
                { data_prod_name: 'Finance', code: 'finance' },
                { data_prod_name: 'P&O', code: 'pno' },
            ],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        domainSubDomainForm: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        country: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        region: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        filePickUp: {
            value: "Local",
            valueAsObj: { name: "Local" },
            options: [
                { name: "Local" },
                { name: "ADLS" },
                // { name: "Delta Table" },
            ],
            loading: false,
        },
        selectedFile: {
            value: null,
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        addDimensionAndWeightage: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
        },
        adlsList: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
        },
        adlsDirectoryForm: {
            value: "",
            valueAsObj: {},
            options:  [],
            loading: false,
        },
        adlsFileName: {
            value: "",
            valueAsObj: {},
            options: [ ],
            loading: false,
        },
        productName: {
            value: "",
            valueAsObj: {},
            options: [ ],
            loading: false,
        },
        dataSteward: {
            value: "",
            valueAsObj: null,
            options: [],
            loading: false,
        },
        dataAssetOwner: {
            value: "",
            valueAsObj: {},
            options:  [],
            loading: false,
        },
        
    }
}

const homeReducer = (state = INITAL_STATE, { type, payload }) => {
    switch (type) {
        case GET_API_DATA_LIST: {
            return produce(state, (draft) => {

            });
        }
        case SET_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = false;
                draft.apiData[payload.apiField].status =
                    payload.status !== undefined && payload.status !== null
                        ? payload.status
                        : "success";
                draft.apiData[payload.apiField].data = payload.data;
            });
        case SET_FORM_OPTION:
            return produce(state, (draft) => {
                draft.formData[payload.formField].loading = false;
                draft.formData[payload.formField].options = payload.data;
            });
        case RESET_API_DATA:
            return produce(state, (draft) => {
                // draft.apiData[payload.apiField] =
                //     INITAL_STATE.apiData[payload.apiField];
            })
        case LOAD_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = true
                draft.apiData[payload.apiField].status = "loading"
            })
        case SET_FORM_VALUE: {

            return produce(state, (draft) => {

                draft.formData[payload.formField].value = payload.value
            });
        }
        case SET_FORM_VALUEOBJ: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].valueAsObj = payload.valueAsObj
            });
        }
        case SET_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = payload.isError
                draft.formData[payload.formField].errorMessage = payload.errorMessage
            });
        }
        case CLEAR_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = false
                draft.formData[payload.formField].errorMessage = ""
            });
        }
        case CLEAR_ALL_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                Object.keys(draft.formData).forEach((val) => {
                    draft.formData[val].isError = false
                    draft.formData[val].errorMessage = ""
                })

            });
        }
        case RESET_NEWASSETS_FORM: {
            return produce(state, (draft) => {
                Object.keys(draft.formData).map((val) => {
                    draft.formData[val].value = INITAL_STATE.formData[val].value
                    draft.formData[val].valueAsObj = INITAL_STATE.formData[val].valueAsObj
                }
                )

            });
        }
        // Return the current state if no action matches
        default:
            return state;
    }
}
export default homeReducer;